import { Injectable } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { map, Observable, ReplaySubject } from 'rxjs';

const BREAKPOINTS: Record<string, string> = {
    sm: '(min-width: 640px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1024px)',
    xl: '(min-width: 1280px)'
};

@Injectable({
    providedIn: 'root'
})
export class MediaWatcherService {
    private _onMediaChange = new ReplaySubject<{ matchingAliases: string[] }>(1);

    constructor(private _breakpointObserver: BreakpointObserver) {
        this._breakpointObserver
            .observe(Object.values(BREAKPOINTS))
            .pipe(
                map((state: BreakpointState) => {
                    const matchingAliases: string[] = [];
                    const queries = Object.entries(BREAKPOINTS);
                    for (const [alias, query] of queries) {
                        if (state.breakpoints[query]) matchingAliases.push(alias);
                    }
                    return { matchingAliases };
                })
            )
            .subscribe((v) => this._onMediaChange.next(v));
    }

    get onMediaChange$(): Observable<{ matchingAliases: string[] }> {
        return this._onMediaChange.asObservable();
    }

    onMediaQueryChange$(query: string | string[]): Observable<BreakpointState> {
        return this._breakpointObserver.observe(query);
    }
}
